// src/modules/admin/pages/cms/learn-hub/VideoModal.jsx
import React from "react";
import { createPortal } from "react-dom";

const VideoModal = ({ show, onClose, videoUrl, youtubeUrl, title = "Video Preview" }) => {
  if (!show) return null;

  const isYouTube = !!youtubeUrl;
  const embedUrl = youtubeUrl
    ? youtubeUrl.includes("youtube.com") || youtubeUrl.includes("youtu.be")
      ? `https://www.youtube.com/embed/${youtubeUrl.match(/(?:v=|\/)([a-zA-Z0-9_-]{11})/)?.[1]}?autoplay=1`
      : null
    : null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.95)",
        backdropFilter: "blur(8px)",
        zIndex: 999999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: "relative",
          width: "95%",
          maxWidth: "1200px",
          height: "90vh",
          background: "#000",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.8)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "20px",
            background: "rgba(0,0,0,0.7)",
            border: "none",
            color: "#fff",
            fontSize: "40px",
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            cursor: "pointer",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-label="Close"
        >
          ×
        </button>

        {/* Title */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            zIndex: 10,
            background: "rgba(0,0,0,0.6)",
            padding: "10px 20px",
            borderRadius: "12px",
            backdropFilter: "blur(10px)",
          }}
        >
          {title}
        </div>

        {/* Video Player */}
        {isYouTube && embedUrl ? (
          <iframe
            src={embedUrl}
            title="YouTube Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        ) : videoUrl ? (
          <video
            controls
            autoPlay
            controlsList="nodownload"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support video playback.
          </video>
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "24px",
            }}
          >
            No video available
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default VideoModal;